import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  const data = {
    userId: payload.userId
  }

  const result = await http.delete(`/v1/result/${payload.quoteId}/${payload.position}`, { data })
  if (result.data.success) {
    return true
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/result/remove-by-position/RemoveByPosition.js